var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1069_19691)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1069_19691)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 28,
    fill: "url(#paint0_linear_1069_19691)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1934 25.3727C51.0589 26.0147 51.2594 27.2638 50.6411 28.1626L36.1968 49.1625C35.846 49.6724 35.2853 49.9822 34.6821 49.9993C34.0788 50.0163 33.5027 49.7388 33.1257 49.2494L25.4221 39.2495C24.7576 38.3869 24.8923 37.1284 25.7229 36.4383C26.5534 35.7483 27.7654 35.8882 28.4299 36.7507L34.5426 44.6856L47.5068 25.8377C48.125 24.9389 49.3278 24.7307 50.1934 25.3727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.1667,
    stroke: "#84E67C",
    strokeWidth: 1.66667
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1069_19691",
    x: -2,
    y: -2,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0146528 0 0 0 0 0.879167 0 0 0 0 0.204846 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1069_19691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1069_19691",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1069_19691",
    x1: -46.6,
    y1: 103.9,
    x2: 83.6,
    y2: -8.80001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BD23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84E67C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1069_19691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/GreenCheck.074a2daa8bb87f9481057be6fd012644.svg";
export { ForwardRef as ReactComponent };